import { createContext, useContext } from 'react';
import { noop } from 'lodash-es';

const ExpandedFdocContentContext = /* @__PURE__ */ createContext({
  extraZoneRef: null,
  topHeaderControlsRef: null,
  itemPreviewContentBodyRef: null,
  isFullscreen: false,
  onClose: noop,
  extraDropdownMenuItems: [],
  setExtraDropdownMenuItems: noop
});
const useExpandedFdocContentContext = () => {
  return useContext(ExpandedFdocContentContext);
};

export { ExpandedFdocContentContext, useExpandedFdocContentContext };
//# sourceMappingURL=ExpandedFdocContentContext.js.map
